import { isArray, isObject, isString, isUndefined } from 'lodash';
import { useMemo } from 'react';
import { get, type FieldErrors, type FieldValues } from 'react-hook-form';

export const useFieldErrors = (fieldName: string, formErrors: FieldErrors<FieldValues>) => {
  const fieldErrors = get(formErrors, fieldName);

  const errorMessages = useMemo(() => {
    const errorMessages: string[] = [];

    if (isArray(fieldErrors)) {
      fieldErrors
        .filter(f => !isUndefined(f))
        .map((e: typeof formErrors | undefined) => {
          if (!e) {
            return;
          }
          const error = Object.values(e)[0];
          const message = get(error, 'message');

          if (isString(message)) {
            errorMessages.push(message);
          }
        });
    } else if (isObject(fieldErrors)) {
      const message = get(fieldErrors, 'message');

      if (isString(message)) {
        errorMessages.push(message);
      }
    }

    if (!errorMessages.length) {
      return null;
    }

    return errorMessages;
  }, [fieldErrors]);

  return errorMessages;
};
